import { render, staticRenderFns } from "./WheelsItineraryItem.vue?vue&type=template&id=35fd74a5&scoped=true"
import script from "./WheelsItineraryItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelsItineraryItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WheelsItineraryItem.vue?vue&type=style&index=0&id=35fd74a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd74a5",
  null
  
)

export default component.exports